export default __webpack_public_path__ + "static/media/new-patient.60f7268a.wav";